exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-commercial-laundry-js": () => import("./../../../src/pages/commercial-laundry.js" /* webpackChunkName: "component---src-pages-commercial-laundry-js" */),
  "component---src-pages-contact-js": () => import("./../../../src/pages/contact.js" /* webpackChunkName: "component---src-pages-contact-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-request-services-js": () => import("./../../../src/pages/request-services.js" /* webpackChunkName: "component---src-pages-request-services-js" */)
}

